import { useEffect, useRef, useState, type ClipboardEvent } from 'react';
import {
  PAYLINK_DESCRIPTION_MAX_LENGTH,
  willPasteExceedDescriptionLimit,
} from '../SendPaylinkForm/formValues';

export const PAYLINK_DESCRIPTION_PASTE_TRIMMED_MESSAGE = `Pasted text trimmed to ${PAYLINK_DESCRIPTION_MAX_LENGTH} characters`;

const PASTE_TRIMMED_MESSAGE_DURATION_MS = 3000;

export const usePaylinkDescriptionPasteFeedback = () => {
  const [pasteTrimmedMessage, setPasteTrimmedMessage] = useState<string | undefined>();
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(
    () => () => {
      clearTimeout(timeoutRef.current);
    },
    [],
  );

  const onDescriptionPaste = (event: ClipboardEvent<HTMLTextAreaElement>) => {
    const input = event.currentTarget;
    const pastedText = event.clipboardData.getData('text');
    const selectionStart = input.selectionStart ?? 0;
    const selectionEnd = input.selectionEnd ?? 0;

    if (!willPasteExceedDescriptionLimit(input.value, pastedText, selectionStart, selectionEnd)) {
      return;
    }

    clearTimeout(timeoutRef.current);
    setPasteTrimmedMessage(PAYLINK_DESCRIPTION_PASTE_TRIMMED_MESSAGE);
    timeoutRef.current = setTimeout(() => {
      setPasteTrimmedMessage(undefined);
    }, PASTE_TRIMMED_MESSAGE_DURATION_MS);
  };

  return { pasteTrimmedMessage, onDescriptionPaste };
};
